export default "__VITE_ASSET__DilF7gdd__ 300w, __VITE_ASSET__BSRbxPYm__ 500w, __VITE_ASSET__BrC7fRIE__ 800w";